import { useState } from 'react';

import { RecurringContributionFormValues, RecurringContributionFrequency } from '../contribution.types';

export const useRecurringContribution = (initialFormValues?: RecurringContributionFormValues) => {
  const [frequency, setFrequency] = useState<RecurringContributionFrequency>(initialFormValues?.frequency || RecurringContributionFrequency.MONTHLY);
  const [
    recurringFromValues,
    setRecurringFormValues,
  ] = useState<RecurringContributionFormValues>(initialFormValues || {});

  return {
    recurringFromValues,
    setRecurringFormValues,
    frequency,
    setFrequency,
  };
};
